export default "__VITE_ASSET__DaqQ65Mq__"